"use strict"

/*
 effects adapted from jQuery 1.7.1 show() and defaultDisplay() functions in effects.js  
 */
var Effects = /*#__PURE__*/ (function () {
  function Effects() {
    this.elemdisplay = {} // Try to re-use the iframe created below

    this.iframe = null
    this.iframeDoc = null
  }

  var _proto = Effects.prototype

  _proto.show = function show(element, site) {
    if (!element || !element.style || !element.nodeName || !site || !site.document) {
      return
    }

    var doc = site.document,
      nodeName = element.nodeName,
      tempElem,
      display // Get the display value of an element in site's dom

    function getDisplay(el) {
      if (site.getComputedStyle) {
        var style = site.getComputedStyle(el, null)

        if (style) {
          return style.getPropertyValue("display")
        } else {
          return ""
        }
      } else if (el.currentStyle && el.currentStyle.display) {
        // Old IE compatibility
        return el.currentStyle.display
      } else {
        return "none"
      }
    } // Try to handle the simplest case: element has been hidden
    // with a style attribute that has "display: none;"

    if (element.style.display === "none") {
      element.style.display = ""
    } // If just clearing the display value in style attribute
    // worked, we're done here.

    if (getDisplay(element) !== "none") {
      return
    } // Now we know that the element has been hidden with a
    // cascading style from somewhere else. In the next steps
    // we try to find out a default display value we can
    // set to the element's style attribute to force the
    // element visible.
    // Check the local cache for already resolved default display values

    if (this.elemdisplay[nodeName]) {
      element.style.display = this.elemdisplay[nodeName]
      return
    } // Render an element with a matching tag name to site's window's document and see its value
    // We do this to find out the tag's default display value even if the site's CSS
    // has overridden it like
    //   div { display: inline }

    tempElem = doc.createElement(nodeName)
    doc.body.appendChild(tempElem)
    display = getDisplay(tempElem)
    doc.body.removeChild(tempElem) // This case handles the (hopefylly) rare case of site's css hiding by tag name like
    //   div { display: none }
    // We want to show the element even in this case. See the discussion in jQuery bugs
    //   http://bugs.jquery.com/ticket/8996
    //   http://bugs.jquery.com/ticket/9106
    // for their rationale for doing the iframe thing below. Another option would be
    // to use a lookup table for default display values of tags like
    //   http://www.w3.org/TR/CSS2/sample.html
    // but as that doc states, the default display values are browser-dependant
    // (and quirks mode dependant, see e.g. http://www.quirksmode.org/css/quirksmode.html#link4 )

    if (display === "none" || display === "") {
      if (!this.iframe) {
        this.iframe = doc.createElement("iframe")
        this.iframe.frameBorder = this.iframe.width = this.iframe.height = 0
      }

      doc.body.appendChild(this.iframe) // Try to re-use the cached iframe's document. The second clause checks
      // for browsers that don't allow rewriting into the document.

      if (!this.iframeDoc || !this.iframe.createElement) {
        this.iframeDoc = (this.iframe.contentWindow || this.iframe.contentDocument).document
        this.iframeDoc.write((document.compatMode === "CSS1Compat" ? "<!doctype html>" : "") + "<html><body>")
        this.iframeDoc.close()
      }

      tempElem = this.iframeDoc.createElement(nodeName)
      this.iframeDoc.body.appendChild(tempElem)
      display = getDisplay(tempElem)
      doc.body.removeChild(this.iframe)
    }

    this.elemdisplay[nodeName] = display
    element.style.display = display
  }

  return Effects
})()

export default Effects
